module.exports = __webpack_public_path__ + "assets/img/kt-renewed-3.e8fd37aa.png";